import './AudioItem.css';

import useElementSize from "./../../hooks/useElementSize";
import AutoScaleText from "./../autoScaleText/AutoScaleText";
import {useEffect, useState} from "react";
import adaptiveSize from './../../utils/size'

export default function LanguageItem(props) {
  const [size, ref] = useElementSize();
  const [contentWidth, setContentWidth] = useState(0);

  const resolutionUnit = props.resolutionUnit;
  const minFontSizeInPx = adaptiveSize(resolutionUnit, 1);
  const maxFontSizeInPx = adaptiveSize(resolutionUnit, 2);
  const text = props.children
  const borderColor = props.borderColor
  const backgroundColor = props.backgroundColor
  const onItemClick = props.onItemClick
  const height = props.height;
  const id = props.id;

  useEffect(() => {
    if (ref.current && size.width > 0) {
      const computedStyle = window.getComputedStyle(ref.current);
      const border =
          parseFloat(computedStyle.borderRightWidth) +
          parseFloat(computedStyle.borderLeftWidth);
      const padding =
          parseFloat(computedStyle.paddingLeft) +
          parseFloat(computedStyle.paddingRight);
      setContentWidth(size.width - border - padding);
    }
  }, [size.width]);

  const style = {
    "background": backgroundColor,
    "borderColor": borderColor,
    "lineHeight": `${height}px`,
    "height": `${height}px`,
  }
  return (
      <li
        ref={ref}
        onClick={() => {onItemClick(id)}}
        className="audio-item text-4xl"
        style={style}
      >
        <AutoScaleText 
          minFontSizeInPx={minFontSizeInPx}
          maxFontSizeInPx={maxFontSizeInPx}
          maxWidthInPx={contentWidth}
          fontFamily="Montserrat, sans-serif" 
        >
          {text}
        </AutoScaleText>
      </li>
    )
}